import request from '@/axios';

// 投屏记录查询
export const geSdkusercastfactdetailtList = ( params) => {
  return request({
    url: '/lebo-dynamicstore/sdkusercastfactdetail/list',
    method: 'get',
    params: {
      ...params,
    }
  })
}
// 投屏记录数量查询
export const getCount = ( params) => {
  return request({
    url: '/lebo-dynamicstore/sdkusercastfactdetail/getCount',
    method: 'get',
    params: {
      ...params,
    }
  })
}